import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f281874")

_pushScopeId("data-v-6f281874")
const _hoisted_1 = { class: "card-body-profiles" }
const _hoisted_2 = { class: "profile-add-btn" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle pr-20" }, null, -1)
const _hoisted_4 = { class: "provider-profiles-filter" }
const _hoisted_5 = { class: "provider-profiles-filter-input" }
const _hoisted_6 = { class: "provider-profiles-filter-btn" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_8 = { class: "provider-profiles" }
const _hoisted_9 = { class: "provider-profiles-header" }
const _hoisted_10 = { class: "provider-header-profile-name" }
const _hoisted_11 = { class: "provider-header-profile-profile" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "provider-header-profile-empty" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "provider-profile-item"
}
const _hoisted_14 = { class: "provider-profile-name" }
const _hoisted_15 = { class: "provider-profile-date" }
const _hoisted_16 = { class: "provider-profile-edit text-r" }
const _hoisted_17 = { class: "providers-showmore" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.EditProfile(0)))
      }, [
        _hoisted_3,
        _createTextVNode(_toDisplayString(_ctx.$t('provider.create-profile')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          placeholder: "Search by profile name",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchText = $event))
        }, null, 512), [
          [_vModelText, _ctx.searchText]
        ]),
        (_ctx.searchText)
          ? (_openBlock(), _createBlock("i", {
              key: 0,
              class: "icon-f icon-delete-cross fs-10",
              style: {"color":"rgb(173, 172, 183)"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText = ''), _ctx.searchProfile()))
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchProfile()))
        }, [
          _hoisted_7
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('provider.profile-name')), 1),
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.create-date')), 1),
        _hoisted_12
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.itemsToShow, (profile, profileIndex) => {
        return (_openBlock(), _createBlock("div", { key: profileIndex }, [
          (_ctx.showMore || profileIndex < 3)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, _toDisplayString(profile.description), 1),
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.getDate(profile.createDate)), 1),
                _createVNode("div", _hoisted_16, [
                  _createVNode("i", {
                    class: "icon-f icon-pencil-edit fs-16",
                    onClick: ($event: any) => (_ctx.EditProfile(profile.id))
                  }, null, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode("div", _hoisted_17, [
        (_ctx.itemsToShow && _ctx.itemsToShow.length > 3)
          ? (_openBlock(), _createBlock("span", {
              key: 0,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showMore = !_ctx.showMore))
            }, _toDisplayString(_ctx.showMore ? _ctx.$t('btn.show-less') : _ctx.$t('btn.show-more')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})